<div fxLayout="column" fxLayoutGap="24px" >
  <ng-content></ng-content>
</div>